// Event Bus
import {EventBus} from '@/main'

// SweetAlert
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
// Plugins
import i18n from '@/plugins/i18n'
import moment from "moment"

// Services
import StudentDocumentService from '@/services/StudentDocumentService'

// Helpers
import showErrors from '@/helpers/showErrors'

const options = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ffffff',
    icon: 'question'
}
Vue.use(VueSweetalert2, options);

export default function (user) {
    var documents = [];

    // Transcript

    if(user.student_type=='mentora'){
        documents.push({
            text: i18n.t('unofficial_transcript'),
            class: 'ri-file-list-line',
            permission: 'studentdocument_esltranscript',
            language: ['EN'],
            callback: (lang) => {
                StudentDocumentService.downloadEslTranscript(user.id, lang)
                    .then(response => {
                        let fileName = user.student_number +' - '+ user.name+' '+user.surname + ' - Unofficial Transcript.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                    })
                    .catch(e => {
                        showErrors(e, null, true)
                    })
            }
        })

        documents.push({
            text: i18n.t('certificate_of_achievement'),
            class: 'ri-article-line',
            permission: 'studentdocument_eslcertificateofachievement',
            language: ['EN'],
            callback: () => {
                StudentDocumentService.certificate_of_achievement(user.id)
                    .then(response => {
                        let fileName = user.student_number + '-' + i18n.t('certificate_of_achievement') + '.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                    })
                    .catch(e => {
                        showErrors(e, null, true)
                    })
            }
        })

        if (user.program_code === '0702004') {
            documents.push({
                text: i18n.t('youth_program_certificate'),
                class: 'ri-article-line',
                permission: 'studentdocument_youthprogramcertificate',
                callback: () => {
                    StudentDocumentService.downloadYouthProgramCertificate(user.id)
                        .then(response => {
                            let fileName = user.student_number + '-' + i18n.t('youth_program_certificate') + '.pdf'
                            EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                        })
                        .catch(e => {
                            showErrors(e, null, true)
                        })
                }
            })
        }
    }
    else {
        documents.push({
            text: i18n.t('unofficial_transcript'),
            class: 'ri-file-list-line',
            permission: 'studentdocument_transcript',
            language: ['EN'],
            callback: (lang) => {
                StudentDocumentService.downloadTranscript(user.id, lang)
                    .then(response => {
                        let fileName = user.student_number +' - '+ user.name+' '+user.surname + ' - Unofficial Transcript.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                    })
                    .catch(e => {
                        showErrors(e, null, true)
                    })
            }
        })

        if (user.student_status && user.student_status !="102") {
            // Course Schedule
            documents.push({
                text: i18n.t('course_schedule'),
                class: 'ri-article-line',
                permission: 'studentdocument_courseschedule',
                language: ['EN'],
                callback: (lang) => {
                    StudentDocumentService.downloadCourseSchedule(user.id, lang)
                        .then(response => {
                            let fileName = user.student_number + '-' + i18n.t('file_name_course_schedule') +  '.pdf';
                            EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                        })
                        .catch(e => {
                            showErrors(e, null, true)
                        })
                }
            })
        }
    }


    // Mezun
    if (user.student_status && user.student_status == "102") {
        // Diploma
        documents.push({
            text: i18n.t('diploma'),
            class: 'ri-article-line',
            permission: 'studentdocument_diploma',
            language: ['EN'],
            callback: () => {
                let formData =
                    {
                        language: 'EN',
                        response_type: 'pdf',
                    };
                StudentDocumentService.downloadDiploma(user.id, formData)
                    .then(response => {
                        let fileName = user.student_number + '-' + i18n.t('diploma') + '-' + '.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                    })
                    .catch(e => {
                        showErrors(e, null, true)
                    })
            }
        })
    }

return documents;

}

